import { useEducationPlanOop } from '../model';
import { CurriculumTable } from './CurriculumTable';

export const EducationPlanOop = () => {
  const {
    state: { educationPlan },
  } = useEducationPlanOop();
  if (!educationPlan) {
    return null;
  }

  return (
    <>
      {educationPlan.blocks.map((block: any) => (
        <CurriculumTable block={block} key={block.id} />
      ))}
    </>
  );
};
